/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoSysMaintenanceCreateRequest model module.
 * @module model/SystemControllerDtoSysMaintenanceCreateRequest
 * @version 1.0
 */
class SystemControllerDtoSysMaintenanceCreateRequest {
    /**
     * Constructs a new <code>SystemControllerDtoSysMaintenanceCreateRequest</code>.
     * @alias module:model/SystemControllerDtoSysMaintenanceCreateRequest
     * @param isUrgent {Boolean} 
     */
    constructor(isUrgent) { 
        
        SystemControllerDtoSysMaintenanceCreateRequest.initialize(this, isUrgent);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, isUrgent) { 
        obj['isUrgent'] = isUrgent;
    }

    /**
     * Constructs a <code>SystemControllerDtoSysMaintenanceCreateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoSysMaintenanceCreateRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoSysMaintenanceCreateRequest} The populated <code>SystemControllerDtoSysMaintenanceCreateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoSysMaintenanceCreateRequest();

            if (data.hasOwnProperty('isUrgent')) {
                obj['isUrgent'] = ApiClient.convertToType(data['isUrgent'], 'Boolean');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('content')) {
                obj['content'] = ApiClient.convertToType(data['content'], 'String');
            }
            if (data.hasOwnProperty('startedAt')) {
                obj['startedAt'] = ApiClient.convertToType(data['startedAt'], 'Date');
            }
            if (data.hasOwnProperty('endedAt')) {
                obj['endedAt'] = ApiClient.convertToType(data['endedAt'], 'Date');
            }
            if (data.hasOwnProperty('version')) {
                obj['version'] = ApiClient.convertToType(data['version'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoSysMaintenanceCreateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoSysMaintenanceCreateRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SystemControllerDtoSysMaintenanceCreateRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['content'] && !(typeof data['content'] === 'string' || data['content'] instanceof String)) {
            throw new Error("Expected the field `content` to be a primitive type in the JSON string but got " + data['content']);
        }
        // ensure the json data is a string
        if (data['version'] && !(typeof data['version'] === 'string' || data['version'] instanceof String)) {
            throw new Error("Expected the field `version` to be a primitive type in the JSON string but got " + data['version']);
        }

        return true;
    }


}

SystemControllerDtoSysMaintenanceCreateRequest.RequiredProperties = ["isUrgent"];

/**
 * @member {Boolean} isUrgent
 */
SystemControllerDtoSysMaintenanceCreateRequest.prototype['isUrgent'] = undefined;

/**
 * @member {String} title
 */
SystemControllerDtoSysMaintenanceCreateRequest.prototype['title'] = undefined;

/**
 * @member {String} content
 */
SystemControllerDtoSysMaintenanceCreateRequest.prototype['content'] = undefined;

/**
 * @member {Date} startedAt
 */
SystemControllerDtoSysMaintenanceCreateRequest.prototype['startedAt'] = undefined;

/**
 * @member {Date} endedAt
 */
SystemControllerDtoSysMaintenanceCreateRequest.prototype['endedAt'] = undefined;

/**
 * @member {String} version
 */
SystemControllerDtoSysMaintenanceCreateRequest.prototype['version'] = undefined;






export default SystemControllerDtoSysMaintenanceCreateRequest;

